import React from 'react';
import { InputGroup } from '@buildoutinc/blueprint-react/ui/InputGroup';
import { faCirclePlus, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';
import NumberInput from 'components/form/managed_input/number_input';

import { MAX_RADII, MAX_RADIUS, MIN_RADIUS, RADIUS_STEP } from './demographics_constants';
import type { RingEditorProps } from './types';

interface OsRingEditorProps extends RingEditorProps {
  disabled?: boolean;
  distanceUnit?: 'mi' | 'km';
}

export default function OsRingEditor({
  disabled = false,
  distanceUnit = 'mi',
  radiusRings,
  onAddRadiusRing,
  onRadiusRingChange,
  onRemoveRadiusRing
}: OsRingEditorProps) {
  return (
    <div className="d-flex flex-column gap-2">
      {radiusRings.map((radius, index) => (
        <div className="d-flex align-items-center gap-2" key={index}>
          <InputGroup style={{ width: '110px' }}>
            <NumberInput
              aria-label={`Radius ${index + 1}, in ${distanceUnit === 'km' ? 'kilometers' : 'miles'}`}
              className="form-control"
              disabled={disabled}
              inputMode="decimal"
              maxValue={MAX_RADIUS}
              minValue={MIN_RADIUS}
              step={RADIUS_STEP}
              value={radius}
              onChange={() => {}}
              onValueChange={(v: number | null) => onRadiusRingChange(index, v)}
            />
            <InputGroup.Addon asText>{distanceUnit}</InputGroup.Addon>
          </InputGroup>
          {radiusRings.length > 1 && (
            <Button
              aria-label={`Remove Radius ${index + 1}`}
              disabled={disabled}
              icon={faXmark}
              size="sm"
              variant="ghost"
              onClick={() => onRemoveRadiusRing(index)}
            />
          )}
        </div>
      ))}
      {radiusRings.length < MAX_RADII && (
        <Button
          className="align-self-start"
          disabled={disabled}
          icon={faCirclePlus}
          size="sm"
          variant="outline"
          onClick={onAddRadiusRing}
        >
          Add Ring
        </Button>
      )}
    </div>
  );
}
